import { useEffect, useMemo, useState } from 'react'
import cx from 'classnames'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import ImageType from '../types/ImageType'
import Dot from './Dot'
import DotsList from './DotsList'
import Slide from './Slide'
import { BlockSectionTitle, BlockWrapper, Container } from 'common/widgets'
import classNames from './styles.module.scss'


NewsCarousel.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      image: ImageType,
      tag: PropTypes.string,
      heading: PropTypes.string,
      text: PropTypes.string,
      cta: PropTypes.string,
      cta_url: PropTypes.string,
      cta_link_caption: PropTypes.string,
    })),
  }),
  priorityLoad: PropTypes.bool,
}

export default function NewsCarousel({
  data = {
    items: [],
  },
  priorityLoad = false,
}) {
  const [className, setClassName] = useState(classNames.slider)
  const settings = useMemo(() => ({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: DotsList,
    customPaging: Dot,
    pauseOnHover: false,
  }), [])
  const slides = useMemo(() => get(data, 'items', []).map((item, idx) => (
    <Slide key={item.heading} caption={item.cta_link_caption} {...item} priority={priorityLoad && idx === 0} />
  )), [data?.items])

  useEffect(() => {
    setClassName(cx(classNames.slider, classNames.ready))
  }, [])

  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
      </Container>
      <Slider {...settings} className={className}>
        {slides}
      </Slider>
    </BlockWrapper>
  )
}
